import { Route } from "react-router-dom";

export const all_routes = {
  //Home Modules
  homeone: "/index",
  hometwo: "/index-2",
  homethree: "/index-3",
  homefour: "/index-4",
  homefive: "/index-5",
  homesix: "/index-6",

  //Course Modules
  courseGrid: "/course/course-grid",
  courseList: "/course/course-list",
  courseDetails: "/course/course-details",
  courseDetails2: "/course/course-details-2",
  courseCategory: "/course/course-category",
  courseCategory2: "/course/course-category-2",
  courseCategory3: "/course/course-category-3",
  courseResume: "/course/course-resume",
  courseWatch: "/course/course-watch",
  courseCart: "/course/cart",
  courseCheckout: "/course/checkout",
  addNewCourse: "/course/add-course",

  //Instructor Modules
  instructorDashboard: "/instructor/instructor-dashboard",
  instructorProfile: "/instructor/instructor-profile",
  instructorCourse: "/instructor/instructor-course",
  instructorCourseGrid: "/instructor/instructor-course-grid",
  instructorAnnouncements: "/instructor/instructor-announcements",
  instructorAssignment: "/instructor/instructor-assignment",
  instructorQuiz: "/instructor/instructor-quiz",
  instructorQuizResult: "/instructor/instructor-quiz-results",
  instructorCertificate: "/instructor/instructor-certificate",
  instructorEarning: "/instructor/instructor-earnings",
  instructorPayout: "/instructor/instructor-payout",
  instructorStatements: "/instructor/instructor-statements",
  instructorMessage: "/instructor/instructor-message",
  instructorTickets: "/instructor/instructor-contact",
  // Đây là đổi mật khẩu
  // instructorChangePassword:'/instructor/instructor-change-password',
  instructorPlan: "/instructor/instructor-plans",
  instructorSocialProfiles: "/instructor/instructor-social-profiles",
  instructorLinkedAccounts: "/instructor/instructor-linked-accounts",
  instructorNotification: "/instructor/instructor-notifications",
  instructorIntegrations: "/instructor/instructor-integrations",
  // instructorWithdraw:'/instructor/instructor-withdraw',
  // instructorWishlist:'/instructor/instructor-withdraw',
  // instructorReviews:'/instructor/instructor-withdraw',
  instructorQuizAttempts: "/instructor/instructor-withdraw",
  instructorOrders: "/instructor/instructor-withdraw",
  instructorChat: "/instructor/instructor-withdraw",
  // Đây là slidebar của referral instructor
  // instructorReferral:'/instructor/instructor-withdraw',
  instructorQA: "/instructor/instructor-quiz-questions",
  // Route này là của instructor edit profile
  instructorsettings: "/instructor/instructor-settings",

  studentDashboard: "/student/student-dashboard",
  studentProfile: "/student/student-profile",
  studentsGrid: "/instructor/students",
  studentsDetails: "/instructor/students-details",
  studentsList: "/instructor/student-list",
  // route này là order history
  // studentOrderHistory:'/student/student-order-history',
  // studentMessage: "/student/student-messages",
  studentCourses: "/student/student-courses",
  studentCertificates: "/student/student-certificates",

  // student forum
  studentForum: "/student/student-forums",
  studentForumDetails: "/student/student-forums/student-forum-details",

  // student events
  studentEvents: "/student/student-events",

  // student grades
  studentGrades: "/student/student-grades",

  // student progress
  studentProgress: "/student/student-progress",
  studentProgressDetail: "/student/student-progress/student-progress-details",

  // student live classes
  studentLiveClasses: "/student/student-live-classes",
  studentLiveClassesDashboard: "/student/live-classes",

  // route này là wishlist
  // studentWishlist:'/student/student-wishlist',
  studentQuiz: "/student/student-quiz",
  studentQuizQuestion: "/student/student-quiz-questions",
  studentQuizReview: "/student/student-quiz-questions/student-quiz-review",
  studentAssignQuestion: "/student/student-assign-question",
  // route này là slidebar của referral
  // studentReferral:'/student/student-referral',
  // studentTickets: "/student/student-contact",
  // studentSettings: "/student/student-settings",
  studentChangePassword: "/student/student-change-password",
  studentSocialProfile: "/student/student-social-profile",
  studentLinkedAccounts: "/student/student-linked-accounts",
  studentNotification: "/student/student-notifications",
  studentBillingAddress: "/student/student-billing-address",

  cart: "/cart",
  login: "/login",
  register: "/register",
  forgotpassword: "/forgot-password",
  setpassowrd: "/set-password",
  otp: "/otp",
  lockscreen: "/lock-screen",
  privacyPolicy: "/pages/privacy-policy",
  termsConditions: "/terms-conditions",
  contactUs: "pages/contact-us",
  about_us: "/pages/about-us",
  invoices: "/pages/invoices",
  FAQ: "/pages/faq",
  pricingPlan: "/pages/pricing-plan",
  Error404: "/pages/error-404",
  Error500: "/pages/error-500",
  underconstruction: "/pages/under-construction",
  comingSoon: "/pages/coming-soon",
  becomeAnInstructor: "/pages/become-an-instructor",
  instructorList: "/pages/instructor-list",
  instructorGrid: "/pages/instructor-grid",
  instructorDetails: "/pages/instructor-details",
  notification: "/pages/notifications",
  testimonials: "/pages/testimonials",

  blogGrid: "/blog/blog-grid",
  blogGrid2: "/blog/blog-2-grid",
  blogGrid3: "/blog/blog-3-grid",
  blogDetails: "/blog/blog-details",
  blogCarousal: "/blog/blog-carousal",
  blogMasonry: "/blog/blog-masonry",
  blogLeftSidebar: "/blog/blog-left-sidebar",
  blogRightSidebar: "/blog/blog-right-sidebar",
  blogLetails: "/blog/blog-details",
  blogDetailsLeftSidebar: "/blog/blog-details-left-sidebar",
  blogDetailsRightSidebar: "/blog/blog-details-right-sidebar",
};
